import { Component, inject, OnInit, input} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
import { DynamicFormService } from '../../shared/components/dynamic-forms-components/dynamic-form.service';
import { FieldConfig, FieldType } from '../../shared/components/dynamic-forms-components/field.interface';
import { GraphqlService } from '../../services/graphql.service';
import { CREATE_FEEDBACK_MUTATION } from '../../modules/feedback/feedback.graphql';
import { NotificationService } from '../../services/notification.service';
import { RatingEnum } from '../../modules/feedback/feedback.model';
import { REQUIRED_VALIDATOR } from '../../shared/components/dynamic-forms-components/custom-validators';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomCarouselComponent } from '../../shared/components/carousel/custom.carousel.component';
import { AuthTopBarComponent } from '../authentication-template/top-bar/auth-top-bar.component';
import {RouterModule, RouterOutlet} from "@angular/router";
import {LoadingBarHttpClientModule} from "@ngx-loading-bar/http-client";

@Component({
  selector: 'app-feedbackform',
  imports: [
    SharedModule,CustomCarouselComponent,  RouterModule, LoadingBarHttpClientModule, AuthTopBarComponent
  ],
  templateUrl: './feedbackform.component.html',
  styleUrl: './feedbackform.component.scss',
})
export class FeedbackformComponent implements OnInit {
  private readonly dynamicFormService = inject(DynamicFormService);
  private readonly notificationService = inject(NotificationService);
  private readonly apollo = inject(GraphqlService);
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);

  meetingId: string | null = null;

  fields: FieldConfig[] = [];
  form!: FormGroup;
  loading = false;

  selectedRating = 0;
  hoveredRating = 0;

  readonly ratingValues = [
    RatingEnum.VERY_BAD,
    RatingEnum.BAD,
    RatingEnum.AVERAGE,
    RatingEnum.GOOD,
    RatingEnum.VERY_GOOD,
  ];

  readonly ratingLabels = ['Very Bad', 'Bad', 'Average', 'Good', 'Very Good'];

get hoverLabel(): string {
  const index = (this.hoveredRating || this.selectedRating) - 1;
  return index >= 0 ? this.ratingLabels[index] : '';
}

   ngOnInit() {

     this.meetingId = this.route.snapshot.paramMap.get('meetingId');

      this.fields = [
        // {
        //   type: FieldType.radiobutton,
        //   key: 'rating',
        //   label: 'Rate  your experience',
        //   options: [
        //     { name: 'VERY BAD', value: RatingEnum.VERY_BAD},
        //     { name: 'BAD', value: RatingEnum.BAD},
        //     { name: 'AVERAGE', value: RatingEnum.AVERAGE},
        //     { name: 'GOOD', value: RatingEnum.GOOD},
        //     { name: 'VERY GOOD', value: RatingEnum.VERY_GOOD},
        //   ],
        //   validations: [REQUIRED_VALIDATOR],
        //   rowClass: 'col-span-12 ',
        //   borderless: true,
        // },
        {
          type: FieldType.textarea,
          label: 'Write Your Review',
          key: 'message',
          placeholder: 'Review or Feedback Message',
          validations: [REQUIRED_VALIDATOR],
          rowClass: 'col-span-12',
        },
        {
          type: FieldType.button,
          label: 'Submit',
          buttonColor: 'primary',
          rowClass: 'col-span-12',
        },
      ];

      this.form = this.dynamicFormService.createControl(this.fields, {});
    }

    setRating(index: number) {
    this.selectedRating = index + 1;
  }

  setHovered(index: number) {
    this.hoveredRating = index + 1;
  }

  clearHover() {
    this.hoveredRating = 0;
  }

    async handleFormSubmit(payload: any) {
    if (!payload) {
      return;
    }

   if (!this.selectedRating) {
      this.notificationService.errorMessage('Please select a star rating.');
      return;
    }


    const input: any = {
      rating: payload.rating,
      message: payload.message,
      meetingId: this.meetingId,

    };

    this.loading = true;
    try {
      await this.apollo.mutate({
        mutation: CREATE_FEEDBACK_MUTATION,
        variables: { input },
      });
      this.form.reset();

      this.notificationService.successMessage('Thank you for your feedback!');
      this.router.navigate(['auth/join-meeting']);
    } catch (error) {
      console.error('Feedback submission failed', error);
      this.notificationService.errorMessage('Failed to submit feedback.');
    } finally {
      this.loading = false;
    }
  }
}
